import React from 'react';
import styled from 'styled-components';
import { sx2CssThemeFn } from '@hotelplan/util.theme.sxc';
import { Container } from 'components/domain/container';
import { NavigationIds } from './navigation/GeoNavigation.types';

const GeoHighlightsSectionWrapper = styled.div(
  sx2CssThemeFn({
    backgroundColor: 'lightGreyThird',
    py: ['50px', 9],
  })
);

const HighlightsSectionContainer = styled(Container)(
  sx2CssThemeFn({
    display: 'flex',
    flexDirection: ['column', 'row'],
  })
);

const HighlightsSectionTitle = styled.h2(
  sx2CssThemeFn({
    fontSize: ['34px', '46px'],
    minWidth: ['auto', '560px'],
    mr: [0, 9],
  })
);

const HighlightsSectionText = styled.div(
  ({ theme }) => theme.text.richText,
  sx2CssThemeFn({
    pt: [6, 0],
    width: '100%',
  })
);

interface IGeoHighlightsSectionProps {
  title: string;
  text: string;
}

const GeoHighlightsSection: React.FC<IGeoHighlightsSectionProps> = ({
  title,
  text,
}) => {
  return (
    <GeoHighlightsSectionWrapper id={NavigationIds.HIGHLIGHTS}>
      <HighlightsSectionContainer>
        <HighlightsSectionTitle>{title}</HighlightsSectionTitle>
        <HighlightsSectionText dangerouslySetInnerHTML={{ __html: text }} />
      </HighlightsSectionContainer>
    </GeoHighlightsSectionWrapper>
  );
};

export default GeoHighlightsSection;
